module.exports = __webpack_public_path__ + "img/pass1.ba722f51.png";